import { dispatcher, ingenuity } from "@quest/base-core";
import { TopLogoView } from "@quest/murka-games-behavior-panther/dist/Game/TopLogo/TopLogoView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class TopLogoViewGame extends TopLogoView{
    constructor(viewJson:any, stateView:any){
        super(viewJson, stateView);
        this.subscribeEvents();
    }

     protected resize(e?: any): void {
     if (!ingenuity.deviceEnv.isDesktop) {
            if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
                this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
                this.updateOrientation();
            }
        }
    super.resize(e);
  }
  
    subscribeEvents(){
        this.unSubscribeEvents();
            dispatcher.on(eventDispatchers.TOP_LOGO_HIDE, this.topLogoHide, this);
            dispatcher.on(eventDispatchers.TOP_LOGO_SHOW, this.topLogoShow, this);

            dispatcher.on(eventDispatchers.SHOW_TOP_LOGO,this.showView,this);
            dispatcher.on(eventDispatchers.HIDE_TOP_LOGO,this.hideView,this)
            
        }
        
        unSubscribeEvents(){
        dispatcher.on(eventDispatchers.TOP_LOGO_HIDE, this.topLogoHide, this);
        dispatcher.on(eventDispatchers.TOP_LOGO_SHOW, this.topLogoShow, this);
        
        dispatcher.off(eventDispatchers.SHOW_TOP_LOGO,this.showView,this);
        dispatcher.off(eventDispatchers.HIDE_TOP_LOGO,this.hideView,this) 
    }
  // Add to hide portrait logo on big win
  private topLogoHide(): void {
    this.getContainerByID("topLogoContainer").visible = false;
  }

  // Add to show portrait logo on big win
  private topLogoShow(): void {
    this.getContainerByID("topLogoContainer").visible = true;
  }
    /**to allign game logo at top */
    public topSpace():void {
        if (this.currentStateView) {
            const logoHeightBg = this.getShapeById("logoHeightBg");
            if (logoHeightBg) {
                const wrapperTopBarHeight = SlotConstantsBehavior.WrapperTopBarHeightMobilePortrait;
                const reelBgHeight = SlotConstantsBehavior.REEL_MAXSCALE_HEIGHT;
                const topSpace = ((window.innerHeight / 2 + SlotConstantsBehavior.ADD_IN_Y) - (reelBgHeight / 2) * this.currentStateView.scale.x) - (wrapperTopBarHeight);
                const availableScaling = Math.min(topSpace / logoHeightBg.height, window.innerWidth / logoHeightBg.width);
                dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_LANDSCAPE_LOGO);
                this.showView();
                this.scale.set(availableScaling);
                this.pivot.set(logoHeightBg.width / 2, logoHeightBg.height / 2);
                this.x = window.innerWidth / 2;
                this.y = wrapperTopBarHeight + topSpace / 2;
            }
            if(ingenuity.configData.showLogoBaseGameScreen){
                ingenuity.currentGame.stage.addChild(this);
            }
        }
    }
}